import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'

import { professionMap } from '../../schemas/profession'
import type { ActiveDropdown } from '../../stores/marketplace/active-filter'
import useActiveFilterStore from '../../stores/marketplace/active-filter'

const CurrentSearchbar = () => {
  const navigate = useNavigate()
  const { selectedProfession, submittedFilters, setActiveDropdown, isUsingExactLocation } = useActiveFilterStore()

  // Profession label
  const professionLabel = selectedProfession ? professionMap[selectedProfession]?.label || 'Profession' : 'Profession'

  // Location (city, state)
  let locationLabel = 'Location'
  if (submittedFilters.city && submittedFilters.state) {
    locationLabel = `${submittedFilters.city}, ${submittedFilters.state}`
  } else if (submittedFilters.city) {
    locationLabel = submittedFilters.city
  } else if (isUsingExactLocation) {
    locationLabel = 'My location'
  }

  // Filter count (clientFocus + expertise)
  const filterCount = useMemo(() => {
    let count = 0
    if (Array.isArray(submittedFilters.expertise)) count += submittedFilters.expertise.length
    if (Array.isArray(submittedFilters.clientFocus)) count += submittedFilters.clientFocus.length
    else if (submittedFilters.clientFocus) count += 1
    return count
  }, [submittedFilters.expertise, submittedFilters.clientFocus])

  const onClickButton = (button: ActiveDropdown) => {
    setActiveDropdown(button)
    navigate(paths.marketplace.filters.path)
  }

  return (
    <div
      className="flex w-full max-w-xl items-center rounded-full bg-white px-4 py-2"
      style={{
        minHeight: 55,
        boxShadow: '0px 0px 7px 1px rgba(27, 48, 41, 0.07)',
        border: '1px solid rgba(216, 216, 214, 0.50)',
      }}
    >
      {/* Profession */}
      <button
        onClick={() => onClickButton('profession')}
        className="flex min-w-0 flex-[0.45] items-center justify-start"
      >
        <span className="truncate text-sm font-semibold text-primary">{professionLabel}</span>
      </button>
      {/* Divider */}
      <div className="mx-3 h-8 w-px bg-input/60" />
      {/* Location */}
      <button onClick={() => onClickButton('where')} className="flex min-w-0 flex-[0.55] items-center justify-start">
        <span className="truncate text-sm font-semibold text-primary">{locationLabel}</span>
      </button>
      {/* Divider */}
      <div className="mx-3 h-8 w-px bg-input/60" />
      {/* Filter count */}
      <button onClick={() => onClickButton('filters')} className="flex items-center justify-center">
        <span className="flex h-8 items-center justify-center rounded-md bg-primary p-1.5 text-sm font-bold text-white shadow-sm">
          {filterCount}
        </span>
      </button>
    </div>
  )
}

export default CurrentSearchbar
